import get from 'lodash/get';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getLocation, matchPath } from 'connected-react-router';
import { constants as ownerDetailsConstants } from '../owner-details/redux';
import { addSuccess, addError } from '../notifications/actions';
import { actions, constants } from './redux';
import Api from '../../utils/Api';

// Loads when the owner details arrive — the same trigger the Crew Inspectors
// tab uses — and only while this tab is the one open.
export function* fetchItems({ payload }) {
  try {
    const { pathname } = yield select(getLocation);
    if (!matchPath(pathname, { path: '/owners/:id/vacancy-contacts' })) return;

    yield put(actions.loadItemRequest());

    const data = yield call(Api.vacancyContacts.forOwner, payload.id);

    yield put(actions.addItems(data));
  } catch (e) {
    console.error(e);

    yield put(actions.loadItemsError(e));
  }
}

export function* createItem({ payload: option }) {
  try {
    const ownerId = yield select((s) => s.ownerDetails.data.id);
    const item = yield call(Api.vacancyContacts.createForOwner, ownerId, option.value);

    yield put(actions.addCreatedItem(item));
    yield put(addSuccess(`${option.label} is now a vacancy ad contact for the owner`));
  } catch (e) {
    console.error(e);

    if (get(e, 'apiErrors[0].status') === '422') {
      yield put(addError(`${option.label} is already a vacancy ad contact for this owner`));
    }

    yield put(actions.createItemError(e));
  }
}

export function* deleteItem({ payload: id }) {
  try {
    yield call(Api.vacancyContacts.delete, id);

    yield put(actions.deleteItem(id));
    yield put(addSuccess('Removed from the vacancy ad contacts'));
  } catch (e) {
    yield put(actions.deleteItemError(e));
  }
}

/**
 * getFeatureSagas
 * each saga file should return all feature sagas
 * @returns {ForkEffect[]}
 */
export default function getFeatureSagas() {
  return [
    takeEvery(ownerDetailsConstants.ADD_LOADED_ITEM, fetchItems),
    takeEvery(constants.CREATE_ITEM_REQUEST, createItem),
    takeEvery(constants.DELETE_ITEM_REQUEST, deleteItem),
  ];
}
